import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-circle",
  "use": "icon-circle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-circle\">\n  <path d=\"M512 512m-200 0a200 200 0 1 0 400 0 200 200 0 1 0-400 0Z\" p-id=\"9685\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol